import { useState } from "react"
//import axios from "axios"
import PanelLoading from "../PanelLoading"
import PanelInfiniteScroll from "./PanelInfiniteScroll"
import ImportedArticle from "../articles/ImportedArticle"
import { Button, Box } from "@mui/material"
import { Inventory, Visibility } from "@mui/icons-material"
import { useDispatch, useSelector } from "react-redux"
import {
	selectToolPanelView,
	setToolPanelView,
	TOOL_PANEL_VIEW,
} from "../../reducers/toolPanelViewSlice"
import {
	selectHasMoreUnassignedArticles,
	selectUnassignedArticles,
	incrementPageAndFetchArticles,
	selectCurrentPage,
} from "../../reducers/unassignedArticlesEventsSlice"
import { selectRecentlyViewedArticles, clearArticles, updateArticle } from "../../reducers/recentlyReviewedSlice"
import RawArticle from "../articles/RawArticle"
import { selectWorkspaceExclusions } from "../../reducers/workspaceSlice"
import { checkExclusion } from "../../utils/articleUtilities"
import {useTabPanelScrollEl} from "../panels/TabPanel"
import {useWorkspaceContext} from "../../pages/Dashboard"

export function ToolPanelNav() {
	const dispatch = useDispatch()
	const { workspaceId } = useWorkspaceContext()
	const view = useSelector((state) => selectToolPanelView(state, workspaceId))

	const clearRecentlyViewedArticles = () => {
		dispatch(clearArticles(workspaceId))
	}

	return (
		<Box sx={{ display: "flex", justifyContent: "space-between" }}>
			<Box>
				<Button
					onClick={() =>
						dispatch(setToolPanelView({view: TOOL_PANEL_VIEW.RECENTLY_VIEWED, workspaceId}))
					}
					variant={
						view === TOOL_PANEL_VIEW.RECENTLY_VIEWED ? "contained" : "outlined"
					}
					sx={{ marginRight: "20px" }}
				>
					<Visibility sx={{ marginRight: "10px" }} /> Recently Viewed
				</Button>
				<Button
					onClick={() => dispatch(setToolPanelView({view: TOOL_PANEL_VIEW.UNASSIGNED, workspaceId}))}
					variant={view === TOOL_PANEL_VIEW.UNASSIGNED ? "contained" : "outlined"}
				>
					<Inventory sx={{ marginRight: "10px" }} /> Unassigned
				</Button>
			</Box>
			{
				view && TOOL_PANEL_VIEW.RECENTLY_VIEWED ===  view && (
					<Button
						onClick={clearRecentlyViewedArticles}
						variant={"outlined"}
						color={"error"}
					>
						Clear Recently Viewed
					</Button>
				)
			}
		</Box>
	)
}

export function ToolPanel() {
	const dispatch = useDispatch()
	const { workspaceId } = useWorkspaceContext()
	const view = useSelector((state) => selectToolPanelView(state, workspaceId))
	const unassignedList = useSelector((state) => selectUnassignedArticles(state, workspaceId))

	const hasMore = useSelector((state) => selectHasMoreUnassignedArticles(state, workspaceId))
	const currentPage = useSelector((state) => selectCurrentPage(state, workspaceId))
	const recentlyReviewedArticles = useSelector((state) => selectRecentlyViewedArticles(state, workspaceId))
	const [isLoading] = useState(false)
	const [targetArticle, setTargetArticle] = useState(null)
	const workspaceExcludedArticles = useSelector((state) => selectWorkspaceExclusions(state, workspaceId))
	const setArticleAsImported = (article) => dispatch(updateArticle(article))
	const scrollableTarget = useTabPanelScrollEl()
	
	const paginate = () => {
		// recently viewed is pulled from LocalStorage and doesn't have pagination ATM
		if (view === TOOL_PANEL_VIEW.RECENTLY_VIEWED) return

		if (hasMore) {
			dispatch(incrementPageAndFetchArticles({
				page: currentPage + 1, workspaceId: workspaceId
			}))
		}
	}

	const dataLength = view === TOOL_PANEL_VIEW.RECENTLY_VIEWED ? recentlyReviewedArticles.length :  unassignedList.length

	return (
		<>
			{
				isLoading ? (
					<PanelLoading />
				) : (
					<PanelInfiniteScroll
						fitContent
						dataLength={dataLength}
						hasMore={view === TOOL_PANEL_VIEW.RECENTLY_VIEWED ? false : hasMore}
						loader={<PanelLoading />}
						next={paginate}
						scrollableTarget={scrollableTarget.current}
					>
						{
							view && view === TOOL_PANEL_VIEW.UNASSIGNED && unassignedList.map((result, index) => (
								<ImportedArticle
									key={result.articleId}
									articleWorkspace={result}
									setTargetArticle={setTargetArticle}
									targetArticle={targetArticle}
									isUnassigned={true}
									index={index}
								/>
							))
						}
						{
							view && view === TOOL_PANEL_VIEW.RECENTLY_VIEWED && recentlyReviewedArticles.map((result, index) => {
								const isDeleted = !!result.deletedAt
								if (result.articleId && !isDeleted) {
									return (
										<ImportedArticle
											key={result.articleId}
											articleWorkspace={result}
											setTargetArticle={setTargetArticle}
											targetArticle={targetArticle}
											isUnassigned={ unassignedList.find(unassignedArticle => unassignedArticle.articleId === result.articleId) }
											index={index}
										/>
									)
								} else {
									const rawArticleObject = isDeleted ? result.article : result
									return(
										
										<RawArticle
											key={rawArticleObject.PMID || rawArticleObject.DOI || rawArticleObject.ISBN || rawArticleObject.ARXIVID}
											workspaceId={workspaceId}
											article={rawArticleObject}
											targetArticle={targetArticle}
											setTargetArticle={setTargetArticle}
											setArticleAsImported={setArticleAsImported}
											isExcluded={checkExclusion(rawArticleObject.PMID, workspaceExcludedArticles)}
											index={index}
											deletedAt={isDeleted}
										/>
									)
								}

							})
						}
					</PanelInfiniteScroll>
				)}
		</>
	)
}
